import { CountryCode } from '@dayetopia/types';
import { useLocation } from '@reach/router';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { replaceText } from '@utils/handleTextReplacement';
import { useCountry } from './useCountry';

export default function useReplacedTranslate(country?: CountryCode): { t: (key: string | string[], options?: any) => string } {
  const { t } = useTranslation();
  const { country: contextCountry } = useCountry();
  const location = useLocation();

  return {
    t: (key: string | string[], options?: any) => {
      const translatedText = t(key, options) as unknown as string;
      const result = translatedText ? replaceText(translatedText, country || contextCountry, location) : '';

      return result;
    }
  };
}
